import { TMobileSdkTestsResult } from 'src/apps/dashboard/types/MobileDashboardServiceTypes';
import { MobileRun } from 'src/apps/dashboard/types/MobileRunsTableTypes';
import { returnNonNull } from 'src/common/helpers/ArraysHelper';

import { MobileDashboardMobileSdkTestsQuery } from '../MobileSdkTests.generated';

export const transformMobileSdkTestsResults = (
	rawResults: MobileDashboardMobileSdkTestsQuery
): TMobileSdkTestsResult => {
	const rows: MobileRun[] =
		rawResults.msdk_report_runs?.filter(returnNonNull).map((test) => ({
			id: test.run_id,
			name: test.test_name,
			totalIssues: test.total_issues,
			criticalIssues: test.critical_issues,
			date: test.run_time
		})) ?? [];

	const total = rawResults.total?.[0]?.run_id_count ?? 0;
	const unfilteredTotal = rawResults.unfiltered_total?.[0]?.run_id_count ?? 0;

	return {
		rows,
		total,
		unfilteredTotal
	};
};
